import React from 'react';
import { Tooltip } from 'antd';
import { MessageOutlined } from '@ant-design/icons';

const SendSmsIconButton = ({ onClick, className = '', disabled = false }) => (
  <Tooltip title="ارسال پیامک">
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled) onClick?.(e);
      }}
      disabled={disabled}
      className={`inline-flex items-center justify-center w-5 h-5 rounded text-gray-400 hover:text-emerald-600 hover:bg-emerald-50 dark:hover:bg-emerald-900/20 transition-colors border-0 bg-transparent p-0 cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed ${className}`}
      aria-label="ارسال پیامک"
    >
      <MessageOutlined style={{ fontSize: 12 }} />
    </button>
  </Tooltip>
);

export default SendSmsIconButton;
